import { Preferences } from '@capacitor/preferences';

const KEY_REFRESH = 'agendatp.refreshToken';

let accessTokenEnMemoria: string | null = null;

export function getAccessToken(): string | null {
  return accessTokenEnMemoria;
}

export function setAccessToken(token: string | null): void {
  accessTokenEnMemoria = token;
}

export async function getRefreshToken(): Promise<string | null> {
  const { value } = await Preferences.get({ key: KEY_REFRESH });
  return value;
}

export async function setRefreshToken(token: string): Promise<void> {
  await Preferences.set({ key: KEY_REFRESH, value: token });
}

export async function clearRefreshToken(): Promise<void> {
  await Preferences.remove({ key: KEY_REFRESH });
}

export async function clearTokens(): Promise<void> {
  setAccessToken(null);
  await clearRefreshToken();
}
